<template>
  <div>
    <button class="btn btn-warning mb-1 w-100" @click="open_modal(); getExtract(); getStatus()">
      <font-awesome-icon :icon="['fas', 'receipt']"></font-awesome-icon>
      Extrato
    </button>
    <Dialog
      header="Extrato por filtro"
      v-model:visible="display_modal"
      :breakpoints="{ '960px': '90vw' }"
      :style="{ width: '70vw' }"
      :modal="true"
      id="extractModal"
    >
      <template  v-if="!loader" #header>
        <div class="d-flex align-items-center">
          <h5>Extrato por filtro</h5>
          <button class="btn btn-success ml-3 no-print" @click="print()">
            <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
            Gerar PDF
          </button>
        </div>
      </template>
      <div v-if="loader" class="container-loader">
        <div class="loader"></div>
      </div>
      <div class="row no-gutters" v-if="!loader">
        <div class="col-lg-8 border border-dark mb-3 mb-lg-0">
          <table-risk-status-count :confinedSpacesRiskStatus="extract.confined_spaces_risk_status"></table-risk-status-count>
        </div>
        <div class="col-lg-4 border border-dark mb-3 mb-lg-0">
          <table-status-count :status="status"></table-status-count>
        </div>
      </div>
      <template  v-if="!loader" #footer>
        <p class="text-center mb-2">Equipamentos: {{ extract.total_confined_spaces }}</p>
        <p class="text-center mb-0">
          Total de não conformidades levantadas: {{ extract.total_noncompliances }}
        </p>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import { ref } from 'vue'

  import Dialog from 'primevue/dialog'

  import TableRiskStatusCount from './TableRiskStatusCount.vue'
  import TableStatusCount from './TableStatusCount.vue'
  import { useStore } from 'vuex'
  import { computed } from '@vue/runtime-core'
  import  useSwal from '@/modules/Swal'

  export default {
    props: {
        params: Object
    },
    components: {
      Dialog,
      TableRiskStatusCount,
      TableStatusCount,
    },
    data: function() {
        return initialState()
    },
    methods: {
        getExtract() {
            var app = this;
            var query = '';
            this.resetData()

            if (this.params) {
              const queryStringFilters = Object.keys(this.params)
                  .filter((key) => this.params[key])
                  .map((key) => key + '=' + this.params[key])
                  .join('&')

              query += `&${queryStringFilters}`
            }

            this.fullQueryString = query;
            this.loader = true;

            app.axios
                .get(
                    `/api/orders_of_service/actionPlanStatementConfinedSpace?order_of_service_id=${this.selected_order_of_service.id}${this.fullQueryString}`,
                )
                .then(({ data }) => {
                    this.extract = data
                })
                .catch((error) => {
                    this.display_modal = false;
                    this.showErrorDialog(error.response.data.message);
                    throw new Error(error)
                })
                .finally(() => {
                    this.loader = false;
                })
        },
        getStatus() {
          const app = this;
          let query = '';
          this.resetData()

          if (this.params) {
            const queryStringFilters = Object.keys(this.params)
                .filter((key) => this.params[key])
                .map((key) => key + '=' + this.params[key])
                .join('&')

            query += `&${queryStringFilters}`
          }

          this.fullQueryString = query;
          this.loader = true;

          app.axios
              .get(
                  `/api/action-plan/get-total-by-phase?&confined_space=1&order_of_service_id=${this.selected_order_of_service.id}${this.fullQueryString}`,
              )
              .then(({ data }) => {
                  Object.values(data).forEach(phase => {
                    Object.keys(phase).forEach(key => {
                      this.status[key] += phase[key]
                    })
                  })

                  this.status.budgeted = this.status.budgted
                  this.status.in_adequacy = this.status.inAdequacy
              })
              .catch((error) => {
                  this.display_modal = false;
                  this.showErrorDialog(error.response.data.message);
                  throw new Error(error)
              })
              .finally(() => {
                  this.loader = false;
              })
        },
        resetData: function (){
            Object.assign(this.$data, initialState())
        },
        print() {
          const filtersHTML = document.getElementById('filters').innerHTML;
          const modalHTML = document.getElementById('extractModal').innerHTML;

          let stylesHtml = '';
          for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
          }

          const printWindow = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

          printWindow.document.write(`<!DOCTYPE html>
          <html>
            <head>
              ${stylesHtml}
            </head>
            <body style="background: none;">
              <div style="page-break-after: always">
              ${filtersHTML}
              </div>
              ${modalHTML}
            </body>
          </html>`);

          const inputsIds = [
            'confined-space-id',
            'tag-ambra',
            'tag-confined-space',
            'id-from',
            'id-to',
            'text-search',
          ]

          inputsIds.forEach(id =>
            printWindow.document.getElementById(id).value = document.getElementById(id).value
          )

          printWindow.document.close();
          printWindow.focus();
          printWindow.print();
          printWindow.close();
        },
    },
    setup() {
      const display_modal = ref(false)
      const store = useStore()
      const selected_company = computed(() => store.getters.selected_company)
      const selected_order_of_service = computed(() => store.getters.selected_order_of_service)
      const { showErrorDialog } = useSwal()


      const open_modal = () => {
        display_modal.value = true
      }
      const close_modal = () => {
        display_modal.value = false
      }

      return {
        display_modal,
        open_modal,
        close_modal,
        selected_company,
        selected_order_of_service,
        showErrorDialog
      }
    },
  }

  function initialState() {
      return {
          fullQueryString: '',
          loader: false,
          extract: {
              confined_spaces_risk_status: [],
              total_confined_spaces: null,
              total_max_fine: null,
              total_situations: null,
              total_noncompliances: null
          },
          status: {
            total: 0,
            delegated: 0,
            scheduled: 0,
            budgted: 0,
            inAdequacy: 0,
            projected: 0,
            concluded: 0,
            homologated: 0,
          }
      }
  }
</script>

<style scoped>
  .container-loader {
    height: 300px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
  }
  .loader {
    border: 4px solid #f3f3f3; /* Light grey */
    border-top: 4px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>
